<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d2-d5f88a5f148ed-d1e259"><span id="pageiv">
<p class="dedication-first italic "><em><em class="char-italic italic">For Ollie</em></em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_ded.vue?f1e07a72